module.exports = __webpack_public_path__ + "static/media/3c(2).5e68fb6a.png";